import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ClientService } from '@fitness-force/api';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import { ConfirmedValidator, MinimumLowerCaseCheck, MinimumNumericalCheck, MinimumUpperCaseCheck, SpecialCharacterCheck } from '@fitness-force/shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'client-profile-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    CommonModule,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    BlockUIModule,
    StyleClassModule,
    InputTextModule,
    PasswordModule,
    ErrorMsgComponent,
    MessageModule,
    TranslateModule],
})
export class ChangePasswordComponent implements OnInit {
  @Input() changePasswordModal: boolean | null = false;
  @Input('clientDetails') clientDetails: any;
  @Input('tenantId') tenantId: number=0;
  @Output('closePopup') closePopup = new EventEmitter();

  @Output() closechangePasswordDialog = new EventEmitter();

  resetForm: UntypedFormGroup = new UntypedFormGroup({});
  btnLoading = new BehaviorSubject(false);


  constructor(private fb: UntypedFormBuilder, private clientService: ClientService,
    private toastMessageService: ToastMessageService, public translate: TranslateService) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      new_password: ['', [Validators.required]],
      confirm_password: ['', [Validators.required]]
    },
      {
        validator: [
          SpecialCharacterCheck('new_password', 1),
          MinimumNumericalCheck('new_password', 1),
          MinimumLowerCaseCheck('new_password', 1),
          MinimumUpperCaseCheck('new_password', 1),
          SpecialCharacterCheck('confirm_password', 1),
          MinimumNumericalCheck('confirm_password', 1),
          MinimumLowerCaseCheck('confirm_password', 1),
          MinimumUpperCaseCheck('confirm_password', 1),
          ConfirmedValidator('new_password', 'confirm_password')
        ]
      });
  }



  ValidateAndSubmit(): void {
    this.resetForm.markAllAsTouched();
    if (this.resetForm.valid) {
      this.btnLoading.next(true);
      let newPassword = this.NewPassword.value;
      this.clientService.ChangePassword(this.tenantId,this.clientDetails.id, newPassword)
        .subscribe({
          next: async (data: any) => {
            this.translate.get('STAFF.CHANGEPASSWORD.SUCCESS_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });

            await this.timeout(1000);
            this.btnLoading.next(false);
            this.changePasswordModal = false;
            this.closePopup.emit();
          },
          error: (error: AppErrors) => {
            this.translate.get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
              .subscribe((translation) => {
                this.toastMessageService.showErrorMessage(translation);
              });
              this.btnLoading.next(false);
          },
        });
    }
  }

  ClosePopup(): void {
    this.resetForm.reset();
    this.changePasswordModal = false;
    this.closePopup.emit();
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  get NewPassword() {
    return this.resetForm.controls.new_password;
  }

  get NewConfirmPassword() {
    return this.resetForm.controls.confirm_password;
  }


}

